import styles from "./TableCells.module.scss";

/**
 * The empty cell content for table cells
 */
export const TableEmptyCellContent = () => {
  return (
    <span aria-label="empty table cell" className={styles["empty-cell"]}>
      &mdash;
    </span>
  );
};
